export const SET_LOCALISATION = 'SET_LOCALISATION';

export const setLocalisation = (localisation) => ({
    type: SET_LOCALISATION, localisation
});
